import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { DeleteParticipantNoteLabel } from '../mutations/deleteParticipantNoteLabel';
import type {
  DeleteParticipantNoteLabelMutation,
  DeleteParticipantNoteLabelMutationVariables,
} from '../types';

export const useDeleteParticipantNoteLabelMutation = (
  options?: MutationOptions<
    DeleteParticipantNoteLabelMutation,
    DeleteParticipantNoteLabelMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(DeleteParticipantNoteLabel), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
